<script>
export default {
  props: {
    tag: {
      type: String,
      default: '限时免费'
    },
    title: {
      type: String,
      default: '小满装饰设计免费为你报价'
    },
    content: {
      type: String,
      default:
        '我们将根据你的房屋情况，提供专属报价服务，稍后客服会电话联系你，通具体的服务流程'
    },
    buttonText: {
      type: String,
      default: '立即获取报价'
    },
    visible: { type: Boolean, default: true }
  },
  data() {
    return {
      phoneNumber: ''
    }
  },
  computed: {
    dialogVisible() {
      return this.visible
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    onClickSubmit
  }
}
function onClickSubmit() {
  if (this.phoneNumber.length !== 11) {
    this.$notify({
      message: '请输入正确的11位手机号',
      type: 'warning',
      duration: 3000
    })
  } else {
    this.$emit('click-submit', this.phoneNumber)
  }
}
</script>
<template>
  <div>
    <el-dialog
      :visible="dialogVisible"
      @close="closeDialog"
      class="quation_dialog"
    >
      <div class="quotation_dialog_title">
        <strong>{{ title }}</strong>
      </div>
      <div class="quotation_dialog_title_line line_after_1px" />
      <div class="quotation_text_mobile hide_on_pc">{{ tag }}</div>
      <div class="quotation_dialog_content">
        {{ content }}
      </div>
      <div class="quotation_dialog_input">
        <el-input
          v-model="phoneNumber"
          maxlength="11"
          placeholder="请输入你的手机号"
          oninput="value=value.replace(/[^\d]/g,'')"
        ></el-input>
      </div>
      <div class="quotation_dialog_input_line line_after_1px" />
      <div
        @click="onClickSubmit"
        class="quotation_dialog_submit default_button"
      >
        {{ buttonText }}
      </div>
      <!-- <div style="height:30px;"></div> -->
    </el-dialog>
  </div>
</template>
<style lang="scss">
@media screen and (max-width: 940px) {
  .el-dialog {
    width: 50%;
  }
}

@media screen and (min-width: 940px) {
  .el-dialog {
    width: 30%;
  }

  .el-dialog__body {
    padding-left: 64px;
    padding-right: 64px;
  }
}
.el-dialog__wrapper {
  .el-dialog__body {
    padding-top: 0;
    .quotation_dialog_title {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(68, 68, 68, 1);
      line-height: 20px;
      text-align: center;
    }
    .quotation_dialog_title_line {
      height: 20px;
      display: none;
    }
    .quotation_dialog_content {
      margin: 15px auto 0 auto;
      font-size: 14px;
      font-weight: 400;
      color: rgba(155, 155, 155, 1);
      line-height: 24px;
      text-align: center;
    }
    .quotation_dialog_input {
      margin: 35px auto 0 auto;
      height: 45px;
    }
    .quotation_dialog_input_line {
      height: 15px;
      display: none;
    }

    .quotation_dialog_submit {
      margin: 40px auto 0 auto;
      height: 46px;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 500;
    }
  }
}

@media screen and (max-width: 940px) {
  .el-dialog {
    width: 100%;
  }
  .el-dialog__wrapper {
    > div {
      margin: 0 !important;
      width: 100%;
      background: rgba(255, 255, 255, 1);
      border-radius: 15px 15px 0px 0px;
      position: absolute;
      bottom: 0;
    }
    .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
      .quotation_dialog_title {
        position: relative;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        width: 80%;
        margin: -10px auto 0 auto;
      }
      .quotation_dialog_title_line {
        display: block;
        height: 20px;
      }
      .quotation_text_mobile {
        display: block;
        margin-top: 20px;
        height: 16px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 88, 36, 1);
        line-height: 16px;
      }
      .quotation_dialog_content {
        margin-top: 15px;
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: rgba(68, 68, 68, 1);
      }
      .quotation_dialog_input {
        margin-top: 15px;
        width: 100%;
      }
      .quotation_dialog_input_line {
        display: block;
      }
      .quotation_dialog_submit {
        margin: 13px 0;
        width: 100%;
        height: 43px;
        line-height: 43px;
        font-size: 16px;
      }
    }
  }
}
</style>
